import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

// External components
import ModalBase from "../modalBase/modalBase";

@Component({ components: { ModalBase } })
export default class ModalConfirmOrder extends Vue {
  @Prop({ default: false }) isActive;

  @Action action_confirmSubscriptionOrder;

  @Getter getSubscription;
  @Getter getCity;

  isLoading = false;

  async confirmSubscriptionOrder() {
    const payload = {
      commerceId: this.getCity.id,
      subscriptionId: this.getSubscription.id,
    };
    try {
      this.isLoading = true;
      await this.action_confirmSubscriptionOrder(payload);
      this.$router.replace({ name: "subscriptionOrdersHome" });
      document
        .getElementById("SubscriptionDashboard")
        .scroll({ top: 0, left: 0, behavior: "smooth" });
      this.$swal({
        title: "Pedido confirmado",
        text: "Tu orden ha sido creada. Puedes comenzar a configurar tu siguiente semana.",
      });
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Hubo un error al confirmar el pedido. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.isLoading = false;
  }
}
